class CartUpsellVariantSelector extends HTMLElement {
  constructor() {
    super();
    
    // Only initialize if within cart upsell context
    if (!this.closest('product-info-cart-upsell')) return;
    
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.variantData = JSON.parse(this.dataset.variants || '[]');
    this.currentVariant = parseInt(this.dataset.currentVariant);
    this.updateOptions();
    this.updateVariantSelection();
  }

  updateOptions() {
    // Only select elements within cart upsell context
    if (!this.closest('product-info-cart-upsell')) return;
    const selects = Array.from(this.querySelectorAll('select'));
    this.selectedOptions = selects.map(select => select.value);
  }

  onVariantChange() {
    // Ensure we're in cart upsell context
    if (!this.closest('product-info-cart-upsell')) return;
    this.updateOptions();
    this.updateVariantSelection();
  }

  updateVariantSelection() {
    if (!this.variantData || !this.variantData.length) return;

    const matchingVariant = this.variantData.find((variant) => 
      variant.options.every((option, index) => option === this.selectedOptions[index])
    );

    if (matchingVariant) {
      const form = this.closest('product-info-cart-upsell').querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const input = form.querySelector('input[name="id"]');
        if (input) {
          input.value = matchingVariant.id;

          const submitButton = form.querySelector('[data-cart-upsell-submit]');
          const buttonText = submitButton?.querySelector('.button-text');
          if (submitButton && buttonText) {
            if (matchingVariant.available) {
              submitButton.removeAttribute('disabled');
              buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
            } else {
              submitButton.setAttribute('disabled', '');
              buttonText.textContent = window.variantStrings?.soldOut || 'Sold out';
            }
          }
        }
      }
    }
  }
}

class CartUpsellForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('[data-cart-upsell-submit]');
    this.buttonText = this.submitButton?.querySelector('.button-text');
    this.spinner = this.submitButton?.querySelector('.loading-spinner');

    if (this.form) {
      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }
  }

  async onSubmit(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    if (!this.submitButton || this.submitButton.hasAttribute('disabled')) return;

    this.setLoadingState(true);

    try {
      const formData = new FormData();
      formData.append('id', this.form.querySelector('input[name="id"]').value);
      formData.append('quantity', '1');
      formData.append('form_type', 'product');
      formData.append('utf8', '✓');
      formData.append('sections', 'cart-drawer');

      const response = await fetch(window.Shopify.routes.root + 'cart/add', {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.description || 'Error adding item to cart');
      }

      await this.updateCartDrawer();

    } catch (error) {
      this.showError(error.message);
    } finally {
      this.setLoadingState(false);
    }
  }

  async updateCartDrawer() {
    const response = await fetch(`${window.location.pathname}?section_id=cart-drawer`);
    if (!response.ok) return;
    
    const html = await response.text();
    const parser = new DOMParser();
    const drawerContent = parser.parseFromString(html, 'text/html').querySelector('.drawer__inner');
    
    if (drawerContent) {
      document.querySelector('.drawer__inner').innerHTML = drawerContent.innerHTML;
    }
  }

  setLoadingState(isLoading) {
    if (isLoading) {
      this.submitButton.setAttribute('disabled', '');
      this.buttonText?.classList.add('hidden');
      this.spinner?.classList.remove('hidden');
    } else {
      this.submitButton.removeAttribute('disabled');
      this.buttonText?.classList.remove('hidden');
      this.spinner?.classList.add('hidden');
    }
  }

  showError(message) {
    const errorWrapper = this.querySelector('.product-form__error-message-wrapper');
    const errorMessage = this.querySelector('.product-form__error-message');
    
    if (errorWrapper && errorMessage) {
      errorWrapper.removeAttribute('hidden');
      errorMessage.textContent = message;
      setTimeout(() => errorWrapper.setAttribute('hidden', ''), 5000);
    }
  }
}

if (!customElements.get('cart-upsell-form')) {
  customElements.define('cart-upsell-form', CartUpsellForm);
}

if (!customElements.get('cart-drawer-variant-selects')) {
  customElements.define('cart-drawer-variant-selects', CartUpsellVariantSelector);
}